import icons from '../../img/icons.svg';
import previewView from './previewView';
import View from './View.js';

class BookmarkView extends View {
  _parentElement = document.querySelector('.bookmarks__list');
  _errorMsg = 'Something went wrong in the bookmarks part!';
  _msg = 'No bookmarks yet. Find a nice recipe and bookmark it :)';

  _generateMarkup() {
    return this._data.map((bookmark) => previewView.render(bookmark, false)).join('');
  }

  addHandleRender(handler) {
    window.addEventListener('load', handler);
  }
}

export default new BookmarkView();
